import React, { Component } from "react";
import Proptypes from "prop-types";
import Slider from "react-slick";
import { Helmet } from "react-helmet";
import { CTASliderWrapper } from "./style";
import { Button } from "../../Elements";

class ImageCTACarousel extends Component {
	handlePageChange(url) {
		if (this.props.external_url) {
			window.location.href = url;
		} else {
			let elem = document.getElementById("jobs");
			if (elem) {
				elem.scrollIntoView();
			}
		}
	}

	render() {
		const settings = {
			dots: true,
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 5000,
			fade: true,
			speed: 500,
		};

		return (
			<div>
				<Helmet>
					<link
						rel="stylesheet"
						type="text/css"
						charset="UTF-8"
						href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
					/>
					<link
						rel="stylesheet"
						type="text/css"
						href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
					/>
				</Helmet>
				<CTASliderWrapper>
					<Slider {...settings}>
						{this.props.images.map((image, index) => {
							return (
								<div key={index}>
									<div className="heading">{image?.heading}</div>
									<img className="image" src={image?.image?.image} />
									<div
										className="content"
										dangerouslySetInnerHTML={{
											__html: image?.description?.content,
										}}
									></div>
								</div>
							);
						})}
					</Slider>
					<div className="buttonContainer">
						<a
							className="ctaButton"
							onClick={(e) => this.handlePageChange(this.props.url)}
						>
							<Button type="outline" className="application-button">
								Check the openings
							</Button>
						</a>
					</div>
				</CTASliderWrapper>
			</div>
		);
	}
}

ImageCTACarousel.propTypes = {
	images: Proptypes.array,
};

ImageCTACarousel.defaultProps = {
	images: [],
};

export default ImageCTACarousel;
